module.exports = __webpack_public_path__ + "a16c3c4c1f584ccb16684eb161ba30e6.svg";